// extracted by mini-css-extract-plugin
export var heading = "SectionHeader-module--heading--d3630";